import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Footer } from './containers';
import Navbar from './components/navbar/Navbar';
import Marquee from './components/marquee/Marquee';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import EventsPage from './pages/EventsPage';
import TeamPage from './pages/TeamPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
    <div className="App">
      <div className="gradient__bg">
        <ScrollToTop />
        <Navbar />
        <Marquee />
        <main className="app-shell__main">
          <Routes>
            <Route path="/home" element={<HomePage />} />
            <Route path="/" element={<AboutPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </div>
    </BrowserRouter>
  );
}

export default App;
